import { useConfig } from "./useConfig";

export const useScheduleCallUrl = () => {
  const { contactUs } = useConfig();

  const pathname =
    typeof window !== "undefined" ? window.location.pathname : "";
  const callUrl = new URL(contactUs.callUrl);
  callUrl.searchParams.append("utm_content", pathname);

  return callUrl.toString();
};
